import { useEffect, useState } from "react";
import { api } from "../../lib/api";
import { Dialog, DialogContent, DialogHeader, DialogTitle, DialogDescription } from "../ui/dialog";
import { Button } from "../ui/button";
import { LinkDialog } from "./LinkDialogs";

export function AddToLinks({ contact, onClose }) {
  const [dir, setDir] = useState(null);
  const [scope, setScope] = useState(null);
  useEffect(() => { api.get("/links/directory?manage=true").then(({ data }) => setDir(data)).catch(() => setDir({ can_manage: false, categories: [] })); }, []);
  const name = contact.company || [contact.first_name, contact.last_name].filter(Boolean).join(" ");
  if (scope) {
    return <LinkDialog categories={(dir?.categories || []).filter((c) => c.scope === scope)} onClose={onClose} onSaved={onClose}
      initial={{ _scope: scope, title: name, url: contact.website || "https://", description: [contact.position_title, contact.phone, contact.email].filter(Boolean).join(" \u00b7 ") }} />;
  }
  return (
    <Dialog open onOpenChange={(o) => !o && onClose()}>
      <DialogContent className="max-w-sm" data-testid="add-to-links-dialog">
        <DialogHeader><DialogTitle>Add {name} to Important Links</DialogTitle><DialogDescription className="text-xs text-slate-400 pt-2">Choose where this link should live.</DialogDescription></DialogHeader>
        <div className="grid gap-2">
          {dir?.can_manage && <Button variant="secondary" onClick={() => setScope("org")} data-testid="add-to-links-org">Organisation link (choose who can see it next)</Button>}
          <Button variant="secondary" onClick={() => setScope("personal")} disabled={!dir} data-testid="add-to-links-personal">Private link (only you)</Button>
        </div>
      </DialogContent>
    </Dialog>
  );
}
